import EventsList from '../components/EventsList';
import PageLayout from '../components/pageLayout';

function EventsListPage() {
    return (
        <PageLayout children={<EventsList />} />
    );
}

export default EventsListPage;
